<template>
  <ul
    v-if="system !== 'distributor'"
    class="classification-center"
    :style="{ '--theme-color': shopThemeColor }"
  >
    <li
      v-for="(item, index) in classificationList"
      :key="index"
      class="classification-item"
      @click="selectNav(item)"
    >
      <h2
        class="title"
        :class="{ active_title: String($route.query.activityType) === String(item.activityType) }"
      >
        {{ item.activityTitle }}
      </h2>

      <div v-if="item.activitySlogan" class="activitySlogan_style">
        <span class="text">{{ item.activitySlogan }}</span>
        <span class="activitySlogan_item"></span>
      </div>
    </li>
  </ul>
</template>

<script>
import Mixin from "@/components/mixin/common_mixin";
import {commonSessionStorage} from "@/utils/common";

export default {
  name: "activityTab",
  mixins: [Mixin],

  computed: {
    // 主题色：trs 使用绿色，其它默认橙色
    shopThemeColor() {
      return this.systemEnvironment === 'trs' ? '#89b92a' : '#FD5425';
    },

    classificationList() {
      const sessionData = commonSessionStorage.getItem('ongoingActivitiesData');
      return this.$store.state.ongoingActivitiesData || sessionData || [];
    }
  },

  methods: {
    // 选中商品菜单
    selectNav(item) {
      if (this.system === 'distributor') {
        const protocolArr = window.location.href.split('//');
        const ymsActivityPlanId = item.ymsActivityPlanId
          ? `&ymsActivityPlanId=${item.ymsActivityPlanId}`
          : '';
        const url = `/index.html#/shopList?activityType=${item.activityType}${ymsActivityPlanId}`;

        if (protocolArr[1].includes('localhost')) {
          const link = `${protocolArr[0]}//${window.location.host}${url}`;
          window.open(link, '_blank');
        } else {
          const link = `/yms-shopping-service/${url}`;
          window.open(link, '_blank');
        }
      } else {
        this.$router.push({
          path: '/shopList',
          query: {
            activityType: item.activityType,
            ymsActivityPlanId: item.ymsActivityPlanId
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.classification-center {
  width: 100%;
  min-width: 644px;
  height: 40px;
  display: flex;
  align-items: center;

  .classification-item {
    display: flex;
    box-sizing: border-box;
    position: relative;

    .title {
      font-size: 15px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #000000;
      cursor: pointer;
      padding: 6px 20px;
      border-bottom: 2px solid transparent;
      transition: color 0.2s ease, border-color 0.2s ease;
    }

    .active_title {
      color: var(--theme-color);
      border-bottom: 2px solid var(--theme-color);
    }

    .activitySlogan_style {
      padding: 0 4px;
      color: #fff;
      text-align: left;
      text-decoration: none;
      background-color: #FDA228;
      border-radius: 2px;
      white-space: nowrap;
      position: absolute;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);

      .text {
        font-size: 12px;
        display: inline-block;
      }

      .activitySlogan_item {
        position: absolute;
        width: 0;
        height: 0;
        border-color: transparent;
        border-style: solid;
        bottom: -4px;
        border-width: 4px 4px 0;
        border-top-color: #FDA228;
        left: 50%;
        margin-left: -4px;
      }
    }

    &:hover {
      .title {
        color: var(--theme-color);
      }
    }
  }
}
</style>